import ApiService from './Api.service.js';

class ArchiveService extends ApiService {
  getFileTypes() {
    return this.resource.get("fileTypes");
  }
}

export default new ArchiveService('archives');



// WEBPACK FOOTER //
// ./src/services/axios/archives.service.js